import { motion } from "framer-motion";
import React, { useReducer } from "react";
import { CloseX } from "./Icons/CloseX";
import { ImageComp } from "./ImageComp";
import { Pallette } from "./Pallette";
import { ShowImg2 } from "./ShowImg2";

const reducer = (state, action) => {
  switch (action.type) {
    case "SELECTED":
      return {
        ...state,
        thumb: state.newImages.filter((n) => {
          return n.id === action.payload;
        }),
      };

    default:
      return state;
  }
};

function ShowDcomp2({ state, setState, nonMutable }) {
  const [Deskimage, dispatch] = useReducer(reducer, {
    thumb: [state.thumb],
    newImages: [...state.images],
  });

  return (
    <>
      <motion.div
        className="animate--wrapper--desk"
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="show--wrapper--desk"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 10, transition: { duration: 1.5 } }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <div className="thumbnail--area--desk">
            {Deskimage.thumb.map((d) => {
              return <ImageComp image={d} key="thumb" alt={state.title} />;
            })}
          </div>
          <div className="details--area">
            <div className="top--detail--area">
              <button
                className="close-x"
                onClick={() => {
                  setState({ ...nonMutable });
                }}
              >
                <CloseX />
              </button>
            </div>
            <div className="mid--area">
              <motion.div className="mid--top">
                <motion.h3>{state.title}</motion.h3>
                <motion.p>{state.body.body}</motion.p>
              </motion.div>
              <motion.div className="mid--bottom">
                <motion.h4>Color Pallette</motion.h4>
                <Pallette pal={state.pal} />
              </motion.div>
            </div>
            <div className="other--images--area">
              <ShowImg2
                imgs={Deskimage.newImages}
                dispatch={dispatch}
                title={state.title}
              />
            </div>
          </div>
        </motion.div>
      </motion.div>
    </>
  );
}

export { ShowDcomp2 };
